module.exports = __webpack_public_path__ + "img/115.6.9df2c355.png";